import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//component:
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';
import DatePicker from '../../../components/utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Tooltip, Fade } from '@material-ui/core';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditZonaIvaCentro extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.zonaiva.id ? this.props.zonaiva.id : uuidv4(),
            zonaIva: this.props.zonaiva.zonaIva
                ? this.props.zonaiva.zonaIva
                : this.props.tiposZonaIva[0].descr,
            iTipoZonaIva:
                this.props.zonaiva.iTipoZonaIva !== undefined
                    ? this.props.zonaiva.iTipoZonaIva
                    : this.props.tiposZonaIva[0].id,
            iva: this.props.zonaiva.iva ? this.props.zonaiva.iva : null,
            fIni: this.props.zonaiva.fIni
                ? this.props.zonaiva.fIni.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            fEnd: this.props.zonaiva.fEnd
                ? this.props.zonaiva.fEnd.slice(0, 10)
                : null,
        };
    }

    fillSelect = () => {
        return this.props.tiposZonaIva.map(tzi => {
            return (
                <option key={tzi.id} value={tzi.id}>
                    {tzi.descr}
                </option>
            );
        });
    };

    handleChange = event => {
        this.setState({ iva: event.target.checked });
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    handleSelect = event => {
        const value = parseInt(event.target.value);

        this.setState({
            iTipoZonaIva: value,
            zonaIva: this.props.tiposZonaIva.find(tzi => tzi.id === value)
                .descr,
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <Tooltip
                        title="Zona a la que está asociado el tipo de IVA"
                        TransitionComponent={Fade}
                        TransitionProps={{ timeout: 600 }}
                        classes={{ tooltip: this.props.classes.tooltip }}
                    >
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="tipos-zona-iva-placeholder">
                                Tipo de Zona Iva
                            </InputLabel>
                            <Select
                                native
                                value={this.state.iTipoZonaIva}
                                onChange={event => this.handleSelect(event)}
                                name="zonaIva"
                            >
                                {this.fillSelect()}
                            </Select>
                        </FormControl>
                    </Tooltip>

                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="IVA sobre 100"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <TextField
                                id={'iva'}
                                label={'IVA (%)'}
                                placeholder={'0'}
                                value={this.state.iva}
                                InputProps={{
                                    classes: { input: classes.rtl },
                                    inputComponent: FloatNumberFormatInput,
                                }}
                                onChange={event =>
                                    this.handleValueChange(event, 'iva')
                                }
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Fecha inicio validez del IVA"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            {/* <TextField
                            id={'fIni'}
                            label={'Fecha Inicio'}
                            type="date2"
                            value={this.state.fIni}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => this.handleValueChange(event, 'fIni')}
                        /> */}
                            <DatePicker
                                label={'Fecha Inicio'}
                                value={this.state.fIni}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fIni')
                                    }
                                }}
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip
                            title="Fecha fin validez del IVA (vaío indica sin límite)"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 600 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            {/* <TextField
                id={"fEnd"}
                label={"Fecha Fin"}
                type="date2"
                value={this.state.fEnd}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={event => this.handleValueChange(event, "fEnd")}
              /> */}
                            <DatePicker
                                label={'Fecha Fin'}
                                value={this.state.fEnd}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fEnd')
                                    }
                                    else {
                                        this.handleValueChangeDate(null, 'fEnd')
                                    }
                                }}
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const tipoZona = {
                                ...this.props.zonaiva,
                                id: this.state.id,
                                zonaIva: this.state.zonaIva,
                                iTipoZonaIva: this.state.iTipoZonaIva,
                                iva: this.state.iva ? this.state.iva : 0,
                                fIni: this.state.fIni,
                                fEnd: this.state.fEnd,
                                centroId: this.props.centroid,
                            };

                            if (this.props.checkZonaIva(tipoZona)) {
                                this.props.okHandler(tipoZona);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditZonaIvaCentro.propTypes = {
    zonaiva: PropTypes.object.isRequired,
    tiposZonaIva: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkZonaIva: PropTypes.func.isRequired,
    centroid: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditZonaIvaCentro);
